import styled, { keyframes, css } from "styled-components";


const verticalline = keyframes`
    0% { height: 0;};
    100% { height: 100%};
   }
`
const showBox = keyframes`
    0% { opacity: 1;transform:translateY(-30px);};
    100% { opacity: 1;transform:translateY(0px);};
   }
`

export const Aboutbody = styled.div`
height:100vh;
width:100%;
display:flex;
align-items:center;
justify-content:center;
gap:150px;

@media only screen and (max-width: 900px) {
    flex-direction:column;
    gap:0;
}
`

export const Left = styled.div`
position:relative;
height:550px;
width:750px;
border-radius:10%;

${props=> !props.activeId && `
border-radius:50%;
height:550px;
width:550px;
`}

background-image: linear-gradient(to bottom right, #004fff , #0ff );
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    


    @media only screen and (max-width: 900px) {
        transform:scale(0.8);
    }
    @media only screen and (max-width: 700px) {
    width:550px;
        transform:scale(0.7);
    }
    @media only screen and (max-width: 400px) {
        transform:scale(0.62);
        p{
            font-size:26px;
        }
    }
    @media only screen and (max-width: 350px) {
        transform:scale(0.50);
        p{
            font-size:26px;
        }
    }
`
export const Aboutperson = styled.img`
        position:absolute;
        left:0;
        filter: drop-shadow(-6px 6px 6px rgba(108, 122, 137,.7));

`




export const Details = styled.div`
width:75%;
height:60%;
display: flex;
flex-direction:column;
align-self:end;
overflow:hidden;
`

export const Title = styled.h1`
    padding-left:12%;
    width:75%;
    color:white;
    margin-top:0;
`

export const Discription = styled.p`
    padding-left:12%;
    width:75%;
    color:white;
    margin-top:0;
    font-size:22px;
    text-align: left;
    overflow:scroll;

    &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none; 
`


/////////////////////////////////


const mark2arc = keyframes`
    0% {
        top: 45px;
        left: 440px; /* start */
    }
    100% {
        top: 130px;
        left: 500px; /* end */
    }
`
const mark3arc = keyframes`
    0% {
        top: 45px;
        left: 440px; /* start */
    }
    50% {
        left: 495px; /* max left, top peak */
    }
    100% {
        top: 230px;
        left: 520px; /* end */
    }
`

const mark4arc = keyframes`
    0% {
        top: 45px;
        left: 440px; /* start */
    }
    50% {
        left: 520px; /* max left, top peak */
    }
    100% {
        top: 330px;
        left: 510px; /* end */
    }
`

const mark5arc = keyframes`
    0% {
       top: 45px;
        left: 440px; /* start */
    }
    50% {
        left: 520px; /* max left, top peak */
    }
    100% {
        top: 430px;
        left: 460px; /* end */
    }
`

export const Marker = styled.img`
    position:absolute;
    z-index:20;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    object-fit: contain;
    cursor: pointer;
    top: ${({ top }) => top}px;
    
${props=>props.animatemarker && css`
&.marker2{
   animation: ${mark2arc} 2.5s cubic-bezier(.42, .0, .58, 1);
}
&.marker3{
   animation: ${mark3arc} 2.7s cubic-bezier(0,0,1,1);
}
&.marker4{
   animation: ${mark4arc} 3s cubic-bezier(.42, .0, .58, 1);
}
&.marker5{
   animation: ${mark5arc} 3s cubic-bezier(.42, .0, .58, 1);
}
`}

 ${({ activeId, left, right, active, UID }) =>
    !activeId
      ? `
        left: ${left}px;
      `
      : `
        right: -20px;
    ${activeId === UID && 
        `
        top:20%;
        right:68%

        `}
      `}



   `;

